export const getDynamicFormFieldOptions = (field) => {
  if (field?.valuesToForm?.length) return field.valuesToForm;

  return (field?.dynamicFormFieldOption || []).map((option) => ({
    label: option.name,
    value: option.id,
  }));
};

export const getDynamicFormInitialValues = (fields) => {
  return (fields || []).reduce((initialValues, field) => {
    if (field.defaultValue === undefined || field.defaultValue === null) return initialValues;

    initialValues[field.id] = field.multiselect ? [field.defaultValue] : field.defaultValue;
    return initialValues;
  }, {});
};

export const getDynamicFormAutocompleteValue = (field, value) => {
  const options = getDynamicFormFieldOptions(field);

  if (field.multiselect) {
    const selectedValues = Array.isArray(value) ? value : [];
    return options.filter((option) =>
      selectedValues.some((selectedValue) => String(selectedValue) === String(option.value))
    );
  }

  return options.find((option) => String(option.value) === String(value)) ?? null;
};
